var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg247(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 73,
    viewBox: "0 0 75 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4891 65C50.8212 65 61 54.8162 61 42.5C61 30.1838 50.7994 20 38.4674 20C26.1571 20 16 30.1838 16 42.5C16 54.8162 26.1788 65 38.4891 65ZM38.4891 60.5174C28.506 60.5174 20.5239 52.4879 20.5239 42.5C20.5239 32.5121 28.506 24.5044 38.4674 24.5044C48.4505 24.5044 56.4761 32.5121 56.4978 42.5C56.5196 52.4879 48.4722 60.5174 38.4891 60.5174ZM27.5273 45.2418H38.4674C39.4679 45.2418 40.2291 44.4802 40.2291 43.501V29.2698C40.2291 28.2906 39.4679 27.529 38.4674 27.529C37.5104 27.529 36.7492 28.2906 36.7492 29.2698V41.7602H27.5273C26.5486 41.7602 25.7873 42.5218 25.7873 43.501C25.7873 44.4802 26.5486 45.2418 27.5273 45.2418Z",
    fill: "#1C1C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg247);
export default __webpack_public_path__ + "static/media/24-7.73de111940cab74baf6b146574ae49ea.svg";
export { ForwardRef as ReactComponent };